import axios from 'axios';

const API_URL = process.env.REACT_APP_BASEURL + 'auth';
const API_URL2 = process.env.REACT_APP_BASEURL;

export const registerService = async (reqData: object) => {
  return await axios.post(API_URL + '/signup', reqData);
};

export const loginService = async (reqData: object) => {
  return await axios.post(API_URL + '/login', reqData);
};

export const logoutService = (reqData: object) => {
  return axios.post(API_URL + '/logout', reqData);
};

export const forgotPasswordService = (reqData: object) => {
  return axios.put(API_URL + '/forgotPassword', reqData);
};

export const verifyTokenService = (reqData: object) => {
  return axios.put(API_URL + '/verifyToken', reqData);
};

export const verifyTwoFactorAuthenticationOtp = (reqData: object) => {
  return axios.post(API_URL + '/two-factor-authentication', reqData);
};

export const resendTwoFactorAuthenticationOtp = (reqData: object) => {
  return axios.post(API_URL + '/resend-otp', reqData);
};

export const verifyUpdateAuthMethod = (reqData: object) => {
  return axios.post(API_URL + '/verifyUpdateAuthMethod', reqData);
};

export const enableDisableTwoFactorAuthentication = (reqData: object) => {
  return axios.patch(API_URL + '/update-two-factor-authentication', reqData);
};

export const generateAuthAppQR = () => {
  return axios.get(API_URL + '/generateAuthAppQR');
};

export const setDeviceExamReady = (reqData: object) => {
  return axios.post(`${API_URL}/verifyStoreDevice`, reqData);
};

export const resetPasswordService = (reqData: object) => {
  return axios.put(API_URL + '/resetPassword', reqData);
};

export const registerStudentService = async (reqData: object) => {
  return await axios.post(API_URL + '/registerStudent', reqData);
};
export const getDemoVideo = (reqData: object) => {
  return axios.get(`${API_URL2}cloud/sign-url`, { params: reqData });
};
export const registerTrainingPartner = async (reqData: object) => {
  return await axios.post(API_URL + '/registerSubOrg', reqData);
};
export const updateTrainingPartner = async (reqData: object) => {
  return await axios.put(API_URL + '/editSubOrg', reqData);
};

export const addAwardingBody = async (reqData: any) => {
  return axios.post(API_URL + '/registerAwardingBody', reqData);
};

export const updateAwardingBody = async (reqData: any) => {
  return axios.put(API_URL + '/updateAwardingBody', reqData);
};



// export {
//   registerService,
//   loginService,
// };
